<template>
  <div class="user">
    <img src="@/assets/img/user.svg" alt="user" />
    <div class="user-info">
      <p class="user-info_name">
        {{ user.current.organization.short_name }}
      </p>
      <p
        class="user-info_worker"
        :class="isAdmin ? 'admin' : ''"
        @click="changeUser"
      >
        <i class="el-icon-s-custom" />
        {{ getType(user.user_type) }}
      </p>
      <div>
        <img src="@/assets/img/truck.svg" alt="truck" />
        <span class="user-info_trips">{{ getFioUser }}</span>
      </div>
      <div
        v-if="isAdmin"
        class="pole-rf"
        @click="$router.push({ name: 'Pole' })"
      >
        Поле РФ&nbsp;({{ getPoleQuantity }})
      </div>
    </div>
    <div class="user-rate">
      <el-rate v-model="rate_user" disabled :colors="rate_color" />
      <span class="profile_approve" :class="user.is_approve ? 'yes' : ''">
        профиль {{ user.is_approve ? '' : 'не' }} проверен
      </span>
    </div>
    <el-dialog
      v-if="isAdmin"
      title="Выбор пользователя"
      :visible.sync="dialog_user_list"
      width="80%"
    >
      <users-list @choosed="choosed" />
    </el-dialog>
  </div>
</template>

<script>
import {
  FETCH_POLE_QUANTITY,
  FETCH_POLE_STATUSES,
  GET_POLE_QUANTITY,
} from '@/store/actions/pole'
import { GET_STATISTIC } from '@/store/actions/statistic'
import { mapActions, mapGetters } from 'vuex'
import { user_types } from '@/datas/consts'
import UsersList from '@/components/Tables/UsersList'

export default {
  components: { UsersList },
  data() {
    return {
      rate_user: 5,
      rate_color: ['#2ECC71', '#2ECC71', '#2ECC71'],
      isAdmin: Boolean(
        localStorage.getItem('admin-token') ||
          localStorage.getItem('ceo-token'),
      ),
      dialog_user_list: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'userProfile/userInfo',
      stat: `statistic/${GET_STATISTIC}`,
      getPoleQuantity: `pole/${GET_POLE_QUANTITY}`,
    }),
    getFioUser() {
      return this.user.profile.fio || 'ФИО'
    },
  },
  mounted() {
    this.fetchPoleQuantity()
    this.fetchPoleStatuses()
  },
  methods: {
    ...mapActions({
      fetchPoleQuantity: `pole/${FETCH_POLE_QUANTITY}`,
      fetchPoleStatuses: `pole/${FETCH_POLE_STATUSES}`,
    }),
    getType(n) {
      return user_types[n]
    },
    changeUser() {
      if (this.isAdmin) {
        this.dialog_user_list = true
      }
    },
    choosed() {
      this.dialog_user_list = false

      if (this.isDriverRole) {
        this.$router.push('/home')
      }
    },
  },
}
</script>

<style lang="sass">
.user
  display: flex
  .user-face
    background-repeat: no-repeat
    background-size: cover
    height: 73px
    width: 73px
  .user-info
    display: grid
    height: 89px
    margin: 0 30px
    max-width: 300px
    .user-info_name
      font-weight: bold
      font-size: 24px
      line-height: 28px
      margin: 0
    .user-info_worker
      font-size: 16px
      line-height: 19px
      color: #7F8C8D
      margin: 5px 0
      &.admin
        text-decoration: underline
        cursor: pointer
        color: #2ecc71
    .user-info_trips
      font-size: 14px
      line-height: 14px
      color: #7F8C8D
      margin-left: 10px
  .user-rate
    display: flex
    flex-direction: column
    gap: 10px
    .profile_approve
      font-size: 22px
      color: #E60000
      &.yes
       color: #2ECC71
  .pole-rf
    margin-top: 10px
    font-size: 16px
    color: #E60000
    cursor: pointer
</style>
